// extracted by mini-css-extract-plugin
export default {"link":"MobileMenu_link__ApoDW","userProfile":"MobileMenu_userProfile__llle9"};